const commonConfig = {
  get: (key: string) => {
    if (!window.commonConfig) {
      console.log(
        "[site-bi] Couldn't read from commonConfig because it's missing",
      );

      return;
    }

    return window.commonConfig[key];
  },
  set: (key: 'bsi', bsi: string) => {
    if (!window.commonConfig) {
      console.log(
        "[site-bi] Couldn't update commonConfig because it's missing",
      );

      return;
    }

    window.commonConfig[key] = bsi;

    console.log('Wrote BSI to commonConfig', window.commonConfig);
  },
};

export const getCommonConfig = () => commonConfig;
